"use client";

import { motion } from "framer-motion";
import { X } from "lucide-react";

interface SignUpModalProps {
  showModal: boolean;
  handleCloseModal: () => void;
  handleBackStep: () => void;
  children: React.ReactNode;
}

export default function SignUpModal({
  showModal,
  handleCloseModal,
  handleBackStep,
  children
}: SignUpModalProps) {
  if (!showModal) return null;

  return (
    <motion.div
      className="fixed inset-0 bg-black/60 backdrop-blur-lg flex items-center justify-center z-[9999999] p-4 md:p-8 overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleCloseModal();
        }
      }}
    >
      <motion.div
        className="w-full max-w-4xl h-[82vh] bg-white/95 dark:bg-gray-800/95 rounded-xl md:rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] dark:shadow-[0_20px_60px_-15px_rgba(0,0,0,0.5)] overflow-hidden border border-white/20 dark:border-gray-700/30 backdrop-blur-sm mt-[4rem] flex flex-col pb-[6rem]"
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.95, opacity: 0, y: 10 }}
        transition={{ duration: 0.4, ease: [0.19, 1.0, 0.22, 1.0] }}
        onClick={(e) => e.stopPropagation()} 
      >
        <div className="flex justify-between items-center px-[2rem] p-4 md:p-6 border-b border-gray-100 dark:border-gray-700/50 sticky top-0 bg-white/95 dark:bg-gray-800/95 z-10">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-blue-600 flex items-center justify-center">
            </div>
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">Completar registro</h2>
          </div>
          <button
            onClick={handleCloseModal}
            className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors focus:outline-none"
            aria-label="Cerrar"
          >
            <X className="h-4 w-4 text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        <div className="flex justify-center items-center space-x-2 py-3 px-4 bg-gray-50 dark:bg-gray-800/50 sticky top-[60px] z-10">
          <div className="flex items-center">
            <div className="w-7 h-7 rounded-full flex items-center justify-center bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-300 font-medium text-xs">
              1
            </div>
            <div className="ml-1.5 text-xs font-medium text-blue-600 dark:text-blue-400">Datos básicos</div>
          </div>
          <div className="w-12 h-1 bg-blue-600 dark:bg-blue-500"></div>
          <div className="flex items-center">
            <div className="w-7 h-7 rounded-full flex items-center justify-center bg-blue-600 text-white font-medium text-xs">
              2
            </div>
            <div className="ml-1.5 text-xs font-medium text-gray-900 dark:text-white">Perfil</div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6 custom-scrollbar">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="relative z-10"
          >
            {children}
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
} 